import { HttpService } from '../common/HttpService';

export enum EtaShareCodeState {
    Active = 'active',
    Cancelled = 'cancelled',
    Completed = 'completed'
}

type EtaShareCoordinate = {
    lon: number;
    lat: number;
};

type EtaSharePosition = {
    address: string;
    coordinate: EtaShareCoordinate;
    headingAngle: number;
    updatedOn: string;
};

type EtaShareInfo = {
    route?: {
        destination: {
            address: string;
            coordinate: EtaShareCoordinate;
        };
        eta: string;
        remainingDistance: number;
        updatedOn: string;
    };
    sharingState: EtaShareCodeState;
    sharingStartedOn: string;
    sharingValidUntil: string;
};

export type DriverEtaShareInfo = EtaShareInfo & {
    route?: {
        polyline: string;
    };
    position?: EtaSharePosition;
    driverName: string;
    driverAvatarUrl: string;
    locationSharingEnabled: boolean;
};

export type DispatcherEtaShareInfo = EtaShareInfo & {
    companyName: string;
    companyLogoUrl: string;
};

class EtaShareApi {
    private _abortController?: AbortController;

    constructor(private _httpService: HttpService) {}

    async getDriverEtaShareInfo(code: string): Promise<DriverEtaShareInfo> {
        this._abortController?.abort('getDriverEtaShareInfo: Operation canceled by the user.');
        this._abortController = new AbortController();

        return this._httpService.get(`${process.env.REACT_APP_API_URL_SHARE_ETA}/info/${code}`, {
            signal: this._abortController.signal
        });
    }

    async getDispatcherEtaShareInfo(code: string): Promise<DispatcherEtaShareInfo> {
        this._abortController?.abort('getDispatcherEtaShareInfo: Operation canceled by the user.');
        this._abortController = new AbortController();

        return this._httpService.get(`${process.env.REACT_APP_API_URL_SHARE_ETA}/dispatcher/info/${code}`, {
            signal: this._abortController.signal
        });
    }
}

export { EtaShareApi };
